export const EstadisticasActionTypes = {
  API_RESPONSE_SUCCESS: '@@estadisticas-infotools/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@estadisticas-infotools/API_RESPONSE_ERROR',

  LIST_ESTADISTICAS: '@@estadisticas-infotools/LIST_ESTADISTICAS',
  ADD_ESTADISTICA: '@@estadisticas-infotools/ADD_ESTADISTICA',

  RESET: '@@estadisticas-infotools/RESET'
}
